import FormControlLabel from '@mui/material/FormControlLabel';
import CommentIcon from '../../../assets/icons/onPageCommentIcon.svg';
import CommentIconHighContrast from '../../../assets/icons/onPageCommentIconHighContrast.svg';
import Typography from '@mui/material/Typography';
import Pipe from '../../../assets/icons/pipe.svg';
import { useStyles } from '../AnnotationsAndCommentsVisibilityManager/AnnoAndCommVisibilityManager.styles';
import { highContrastMode } from '../../../utils/highContrastChecker';
import TooltipOne from '../../TooltipOne/TooltipOne.component';
import SwitchOne from '../../SwitchOne/SwitchOne.component';
import { fill } from '../../../utils/contrastSvgAttributes';
import { ReactComponent as AnnotationIcon } from '../../../assets/icons/annotationIcon.svg';

interface AnnoAndCommVisibilityManagerProps {
  annotationsVisible: boolean;
  annotationsVisibilityChanged: (newValue: boolean) => void;
  commentsOnPageVisible: boolean;
  commentsOnPageVisibilityChanged: (newValue: boolean) => void;
  allCommentsOnPageVisible: boolean;
  allCommentsOnPageVisibilityChanged: (newValue: boolean) => void;
}

export const AnnoAndCommVisibilityManager: React.FC<AnnoAndCommVisibilityManagerProps> = (props) => {
  const classes = useStyles();
  return (
    <div
      id="annoAndCommBar"
      style={{
        width: 'calc(100%)',
        borderTop: 'solid 1px rgba(44, 45, 62, 0.3)',
        borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
        paddingTop: '5px',
      }}
      className={highContrastMode ? classes.annoAndCommBar : ''}
    >
      <FormControlLabel
        control={
          <TooltipOne
            title={
              props.annotationsVisible
                ? 'Umieszczone na stronie symbole adnotacji są teraz pokazywane'
                : 'Umieszczone na stronie symbole adnotacji nie są teraz pokazywane'
            }
            placement="top"
          >
            <span>
              <SwitchOne
                disableRipple
                color="primary"
                checked={props.annotationsVisible}
                onChange={(event) => props.annotationsVisibilityChanged(event.target.checked)}
                inputProps={{ 'aria-label': 'przełącznik widoczności adnotacji umieszczonych w obszarze oceniania' }}
              />
            </span>
          </TooltipOne>
        }
        data-testid="Adnotacje"
        label={
          <TooltipOne title="Adnotacje" placement="top">
            <div style={{ marginTop: '6px' }}>
              <AnnotationIcon fill={fill} />
            </div>
          </TooltipOne>
        }
        labelPlacement="start"
        style={{ marginLeft: '10px', marginRight: '0px' }}
      />
      <img src={Pipe} alt="linia pionowa" style={{ height: '30px', verticalAlign: 'middle' }} />
      <FormControlLabel
        control={
          <TooltipOne
            title={
              props.commentsOnPageVisible
                ? 'Umieszczone na stronie symbole komentarzy są teraz pokazywane'
                : 'Umieszczone na stronie symbole komentarzy nie są teraz pokazywane'
            }
            placement="top"
          >
            <span>
              <SwitchOne
                disableRipple
                color="primary"
                checked={props.commentsOnPageVisible}
                onChange={(event) => props.commentsOnPageVisibilityChanged(event.target.checked)}
                inputProps={{ 'aria-label': 'przełącznik widoczności komentarzy umieszczonych w obszarze oceniania' }}
              />
            </span>
          </TooltipOne>
        }
        label={
          <TooltipOne title="Komentarze na stronie" placement="top">
            <img
              src={highContrastMode ? CommentIconHighContrast : CommentIcon}
              alt={'ikona komentarzy umieszczonych w obszarze oceniania'}
              style={{ fill: '#347F42' }}
            />
          </TooltipOne>
        }
        labelPlacement="start"
        style={{ marginLeft: '10px', marginRight: '0px' }}
      />
      {props.commentsOnPageVisible && (
        <FormControlLabel
          control={
            <TooltipOne
              title={
                props.allCommentsOnPageVisible
                  ? 'Umieszczone na stronie treści wszystkich komentarzy są teraz pokazywane jednocześnie'
                  : 'Umieszczone na stronie treści komentarzy są teraz pokazywane i ukrywane po wskazaniu i wybraniu symbolu danego komentarza'
              }
              placement="top"
            >
              <span>
                <SwitchOne
                  disableRipple
                  color="primary"
                  checked={props.allCommentsOnPageVisible}
                  onChange={(event) => props.allCommentsOnPageVisibilityChanged(event.target.checked)}
                  inputProps={{
                    'aria-label': 'przełącznik widoczności wszystkich komentarzy umieszczonych w obszarze oceniania',
                  }}
                />
              </span>
            </TooltipOne>
          }
          label={<Typography fontSize={14}>Rozwiń</Typography>}
          labelPlacement="start"
          style={{ marginLeft: '5px', marginRight: '0px' }}
        />
      )}
    </div>
  );
};
